module.exports = __webpack_public_path__ + "img/solution4.5212fa83.png";